module.exports = __webpack_public_path__ + "img/total_siswa.94c4cc23.png";